import { mergeTwClasses } from '@utils/merge-tw-classes';

import { CalloutColor, Props } from './callout.types';

// Tremor also emitted `bg-opacity-10 dark:bg-opacity-10`, removed in Tailwind 4 and therefore inert:
// the solid backgrounds below replicate today's effective rendering.
const COLOR_CLASSES: Record<CalloutColor, string> = {
  amber: 'bg-amber-500 dark:bg-amber-500 border-amber-700 dark:border-amber-700 text-amber-700 dark:text-amber-700',
  'gray-600': 'bg-gray-600 dark:bg-gray-600 border-gray-600 dark:border-gray-600 text-gray-600 dark:text-gray-600',
};

export const Callout = ({ title, icon: Icon, color, className, children, ...props }: Props) => (
  <div
    className={mergeTwClasses(
      'flex flex-col overflow-hidden rounded-lg text-sm border-l-4 py-3 pr-3 pl-4',
      color && COLOR_CLASSES[color],
      className
    )}
    {...props}>
    <div className='flex items-start'>
      {Icon && <Icon className='flex-none h-5 w-5 mr-1.5' />}
      <h4 className='font-semibold'>{title}</h4>
    </div>
    <p className={mergeTwClasses('overflow-y-auto', children ? 'mt-2' : '')}>{children}</p>
  </div>
);
